// router
import { ROUTES } from 'router';

// components
import { Background } from '@karehero/llama/components/atoms/Background/Background';
import { FloatingActions } from '@karehero/llama/components/molecules/FloatingActions/FloatingActions';
import { Instruction } from '@karehero/llama/components/molecules/Instruction/Instruction';

import { theme } from '@karehero/llama/theme';

/**
 * CareConciergeReferralEmailConfirmation asks an organization owner to confirm
 * their email address.
 */
export const CareConciergeReferralEmailConfirmation = () => {
  return (
    <Background color={theme.color.neutral[20]}>
      <Instruction
        title='Almost there!'
        subTitle="Please verify it's you by clicking the link in your email to register for your account."
        instruction='Complete your referral by heading over to your SJP email inbox!'
      />

      <FloatingActions
        actions={[
          {
            label: 'Done',
            to: ROUTES.SIGN_IN,
            variant: 'secondary',
          },
        ]}
      />
    </Background>
  );
};

export default CareConciergeReferralEmailConfirmation;
